import _ from 'lodash';
import grid from 'utils/lsp-grid/grid';

const DEFAULT_SORT_COLUMN = 'templateTypeName';
const DEFAULT_SORT_DIRECTION = 'asc';

const NOTIFICATION_CONTEXT = 'notificationTemplates';

function initializeModel(deps, model) {
  return _.merge(model, {
    notificationTemplates: {
      listMultilang: {
        language: model.session.locale,
      },
      emailList: {
        language: model.session.locale,
        languageValidation: {},
      },
      template: {},
      emailGrid: grid.applyGrid(deps, emailTemplatesList.bind(null, deps), 'notificationTemplates.emailGrid', {
        [deps.config.pageSizeKey]: deps.config.defaultPageSize[2],
        [deps.config.sortColumnKey]: DEFAULT_SORT_COLUMN,
        [deps.config.directionKey]: DEFAULT_SORT_DIRECTION,
      }),
      templates: {},
    },
  });
}

function emailTemplatesList(deps, model) {
  return deps.restSrv.list(NOTIFICATION_CONTEXT, model.session.rest.emailNotifications.templates.url).then((data) => _.sortBy(data, [DEFAULT_SORT_COLUMN]));
}

function fetchTemplate(deps, model, templateId) {
  return deps.restSrv.list(NOTIFICATION_CONTEXT, model.session.rest.emailNotifications.template.get.url, null, { id: templateId }).then((data) => {
    model.notificationTemplates.template[templateId] = data;
    return model;
  });
}

function updateTemplate(deps, model, templateId, templateData) {
  return deps.restSrv.update(NOTIFICATION_CONTEXT, model.session.rest.emailNotifications.template.update.url, templateData, { id: templateId }).then(() => fetchTemplate(deps, model, templateId));
}

export default {
  initializeModel,
  fetchTemplate,
  updateTemplate,
};



// WEBPACK FOOTER //
// ./src/modules/email-notification-templates/logic/email-notification-templates.js